"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.andForOption = void 0;
/**
 *  Return _b_ if _a_ is `Some(T)`.
 *  Otherwise, return _a_.
 */
function andForOption(a, b) {
    if (a.ok) {
        return b;
    }
    return a;
}
exports.andForOption = andForOption;
